import React from "react"
import ToggleIconButton from "common/components/ToggleIconButton";

export default class PassiveIconButton extends React.Component {
  render () {
    return <ToggleIconButton {...this.props} style={{cursor:'default'}} />
  }
}